import { styled } from '@mui/material/styles';
import { Paper } from '@mui/material';

export const MenuSurface = styled(Paper)(({ theme }) => ({
  maxWidth: '100%',
  minWidth: 200,
  background: theme.palette.background.paper,
  boxShadow: theme.shadows[8]
}));
